module.exports = __webpack_public_path__ + "img/6.a40aefd9.png";